import { NOTIFICATIONS } from "consts/notifications";
import { AiModeEnum } from "types/coreSettings";

export enum AIField {
  IsAIAssistantAllowed = "isAIAssistantAllowed",
  IsAIAssistantForUsersAllowed = "isAIAssistantForUsersAllowed",
  AiMode = "aiMode",
}

export const notificationMessage = {
  [AIField.IsAIAssistantAllowed]: NOTIFICATIONS.IS_APP_CONFIG_UPDATED,
  [AIField.IsAIAssistantForUsersAllowed]: NOTIFICATIONS.IS_APP_CONFIG_UPDATED,
  [AIField.AiMode]: NOTIFICATIONS.IS_APP_CONFIG_UPDATED,
};

export type StateValues = {
  [AIField.IsAIAssistantAllowed]: undefined | boolean;
  [AIField.IsAIAssistantForUsersAllowed]: undefined | boolean;
  [AIField.AiMode]: undefined | null | AiModeEnum;
};

export const initialState: StateValues = {
  [AIField.IsAIAssistantAllowed]: undefined,
  [AIField.IsAIAssistantForUsersAllowed]: undefined,
  [AIField.AiMode]: undefined,
};

export type LoadingStateValues = Record<keyof StateValues, boolean>;

export const initialLoadingState: LoadingStateValues = {
  [AIField.IsAIAssistantAllowed]: false,
  [AIField.IsAIAssistantForUsersAllowed]: false,
  [AIField.AiMode]: false,
};

export type AISettingsKey =
  | AIField.IsAIAssistantAllowed
  | AIField.AiMode
  | AIField.IsAIAssistantForUsersAllowed;

export type ConfirmModalType = {
  key: AIField;
  value: boolean;
};
